// Third-party
import React from 'react';

interface Props {
  disclaimers: string[];
}

const DisclaimerFooter = ({ disclaimers }: Props) => {
  const disclaimer = disclaimers.join(' ');

  return (
    <div className="disclaimer-footer">
      <span>{`*${disclaimer}`}</span>
    </div>
  );
};

export default DisclaimerFooter;
